import {
  type OrderDetailWithoutShuffling,
  type OrderV3,
  type CustomerOrdersV3Params,
} from '@hungryroot/rest';
import { useGetOrders } from './useGetOrders';
import { useGetOrdersV3 } from './useGetOrdersV3';

/**
 * Note: Unlike useGetOrder, this hook does not have a side effect of shuffling the order and is safe to use in the onboarding flow or elsewhere.
 */
export function useNextOrder(options?: { enabled?: boolean }) {
  const {
    data: upcomingOrders,
    isLoading,
    isFetching,
  } = useGetOrders({ time_bucket: 'upcoming', limit: 1 }, options);

  let order: OrderDetailWithoutShuffling | undefined = undefined;

  if (!isLoading && upcomingOrders?.results) {
    order = upcomingOrders.results[0];
  }

  return { isLoading, isFetching, order };
}

export function useNextOrderV3(
  params: CustomerOrdersV3Params = {},
  options?: { enabled?: boolean }
) {
  const {
    data: upcomingOrders,
    isLoading,
    isFetching,
  } = useGetOrdersV3(
    {
      ...params,
      time_bucket: 'upcoming',
      limit: 1,
    },
    options
  );

  let order: OrderV3 | undefined = undefined;

  if (!isLoading && upcomingOrders?.results) {
    order = upcomingOrders.results[0];
  }

  return { isLoading, isFetching, order };
}
